import { render, staticRenderFns } from "./adminInfoCenter.vue?vue&type=template&id=dd80a9d0&scoped=true&"
import script from "./adminInfoCenter.vue?vue&type=script&lang=js&"
export * from "./adminInfoCenter.vue?vue&type=script&lang=js&"
import style0 from "./adminInfoCenter.vue?vue&type=style&index=0&id=dd80a9d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd80a9d0",
  null
  
)

export default component.exports